export enum SupportedLanguages {
  English = "en",
  Spanish = "es",
  German = "de",
  Chinese = "zh",
  French = "fr",
  Italian = "it",
  Portuguese = "pt",
  Japanese = "ja",
  Russian = "ru",
  Hindi = "hi",
  Korean = "ko",
  Catalan = "ca",
  Polish = "pl",
  Norwegian = "no",
  Estonian = "et",
  Lithuanian = "lt",
  Swedish = "sv",
}

export enum SupportedCountries {
  UnitedStates = "US",
  Canada = "CA",
  Mexico = "MX",
  Argentina = "AR",
  Colombia = "CO",
  Ecuador = "EC",
  Brazil = "BR",
  Peru = "PE",
  CostaRica = "CR",
  ElSalvador = "SV",
  Guatemala = "GT",
  Honduras = "HN",
  DominicanRepublic = "DO",
  Nicaragua = "NI",
  Chile = "CL",
  Japan = "JP",
  Panama = "PA",
  UnitedKingdom = "GB",
  France = "FR",
  Spain = "ES",
  Norway = "NO",
  Estonia = "EE",
  Lithuania = "LT",
  Sweden = "SE",
  Venezuela = "VE",
}

export const LanguageToCountry: Record<SupportedLanguages, string> = {
  [SupportedLanguages.English]: "US",
  [SupportedLanguages.Spanish]: "ES",
  [SupportedLanguages.German]: "DE",
  [SupportedLanguages.Chinese]: "CN",
  [SupportedLanguages.French]: "FR",
  [SupportedLanguages.Italian]: "IT",
  [SupportedLanguages.Portuguese]: "BR",
  [SupportedLanguages.Japanese]: "JP",
  [SupportedLanguages.Russian]: "RU",
  [SupportedLanguages.Hindi]: "IN",
  [SupportedLanguages.Korean]: "KR",
  [SupportedLanguages.Catalan]: "ES",
  [SupportedLanguages.Polish]: "PL",
  [SupportedLanguages.Norwegian]: "NO",
  [SupportedLanguages.Estonian]: "EE",
  [SupportedLanguages.Lithuanian]: "LT",
  [SupportedLanguages.Swedish]: "SE",
};

export const BETA_LANGUAGES: SupportedLanguages[] = [
  SupportedLanguages.Portuguese,
  SupportedLanguages.German,
  SupportedLanguages.French,
  SupportedLanguages.Italian,
  SupportedLanguages.Russian,
  SupportedLanguages.Japanese,
  SupportedLanguages.Chinese,
  SupportedLanguages.Korean,
  SupportedLanguages.Hindi,
  SupportedLanguages.Catalan,
  SupportedLanguages.Polish,
  SupportedLanguages.Norwegian,
  SupportedLanguages.Estonian,
  SupportedLanguages.Lithuanian,
  SupportedLanguages.Swedish,
];

export function getFlag(langCode: SupportedLanguages): string {
  const countryCode = LanguageToCountry[langCode];
  if (!countryCode) return "";
  return countryCode.replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}
